/**
 * 能链品牌通 - 展示格式化工具
 */

// 空值统一占位符（除折线/柱状图外，字段为空均展示 '--'）
export const EMPTY = '--'

/**
 * 数值格式化（全页统一：语音播报 / 种草码 / 短信 / PUSH / 折线柱状图数值）：
 * - 5 位数及以上（|n| >= 10000）显示为「数字+万」，万位保留 2 位小数且截断（不四舍五入），
 *   如 12399 -> 1.23万、30000 -> 3.00万；
 * - 不足 5 位按千分位展示；
 * - null/undefined/空串/非数字 返回 '--'；0 返回 '0'。
 * @param {number|null} n
 * @returns {string}
 */
export function fmtNum (n) {
  if (n === null || n === undefined || n === '') return EMPTY
  const num = Number(n)
  if (isNaN(num)) return EMPTY
  if (Math.abs(num) >= 10000) {
    // 截断到 2 位小数（不四舍五入）：以 0.01万=100 为单位取整
    return (Math.trunc(num / 100) / 100).toFixed(2) + '万'
  }
  return num.toLocaleString('en-US')
}
